<template>
  <div>
    <img :src="qrCodeImg" :style="qrStyle"/>
  </div>
</template>

<script>
  import QrCode from 'qrcode'
  export default {
    name: 'qrcode-img',
    props: ['qrUrl','qrStyle'],
    data() {
      return {
        qrCodeImg: '111'
      };
    },
    methods: {
      getQrCode(){
      const that = this;
        QrCode.toDataURL(this.qrUrl, function (err, url) {
          that.qrCodeImg=url;
        });
      }
    },
    mounted() {
      console.log("qrcodeimg mounted");
      this.getQrCode();
    }


  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QrcodeImg.vue